<div class="container mt-4">
  <div class="row">
    <div class="col-md-8">
      <div class="section-title-cart">
        <h4 style="font-size: 24px" class="title">Cart Items</h4>
      </div>
      <div *ngIf="cartItems.length > 0; else emptyCart">
        <div class="shopping-cart-form table-responsive">
          <div>
            <table class="table text-center">
              <thead>
                <tr>
                  <th class="product-remove">&nbsp;</th>
                  <th class="product-thumb">&nbsp;</th>
                  <th class="product-name">Product</th>
                  <th class="product-price">Price</th>
                  <th class="product-quantity">Quantity</th>
                  <th class="product-subtotal">Total</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of cartItems">
                  <tr class="cart-product-item">
                    <td class="product-remove">
                      <a (click)="removeItem(item.id)"
                        ><i
                          style="font-size: 25px; color: brown"
                          class="fa fa-trash-o"
                        ></i
                      ></a>
                    </td>
                    <td class="product-thumb">
                      <a>
                        <img
                          src="{{ item.image }}"
                          width="90"
                          height="110"
                          alt="Image-HasTech"
                        />
                      </a>
                    </td>
                    <td class="product-name">
                      <h4 style="font-size: 20px" class="title">
                        {{ item.name }}
                      </h4>
                    </td>
                    <td class="product-price">
                      <span class="price">
                        ₹{{ item.price }} x {{ item.quantity }}</span
                      >
                    </td>
                    <td class="product-quantity">
                      <div class="pro-qty">
                        <button
                          class="qty-btn minus"
                          (click)="decreaseQuantity(item)"
                        >
                          −
                        </button>
                        <input
                          type="text"
                          class="quantity"
                          title="Quantity"
                          [(ngModel)]="item.quantity"
                          (change)="validateQuantity()"
                        />
                        <button
                          class="qty-btn plus"
                          (click)="increaseQuantity(item)"
                        >
                          +
                        </button>
                      </div>
                      <!-- <div class="pro-qty">
                        <input
                          type="text"
                          class="quantity"
                          title="Quantity"
                          [(ngModel)]="item.quantity"
                          (change)="calculateTotalPrice()"
                        />
                      </div> -->
                    </td>
                    <td class="product-subtotal">
                      <span class="price">
                        ₹ {{ item.price * item.quantity }}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="shipping-form-cart-totals">
        <div class="section-title-cart">
          <h5 style="font-size: 24px" class="title">Cart totals</h5>
        </div>
        <div class="cart-total-table">
          <table class="table">
            <tbody>
              <tr class="cart-subtotal">
                <td>
                  <p class="value">Subtotal</p>
                </td>
                <td>
                  <p class="price">₹{{ totalPrice | number : "1.2-2" }}</p>
                </td>
              </tr>
              <tr class="shipping">
                <td>
                  <p class="value">Shipping</p>
                </td>
                <td>
                  <ul class="shipping-list">
                    <li class="radio">
                      <input type="radio" name="shipping" id="radio1" checked />
                      <label for="radio1"><span></span> Flat Rate</label>
                    </li>
                    <li class="radio">
                      <input type="radio" name="shipping" id="radio2" />
                      <label for="radio2"><span></span> Free Shipping</label>
                    </li>
                    <li class="radio">
                      <input type="radio" name="shipping" id="radio3" />
                      <label for="radio3"><span></span> Local Pickup</label>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr class="order-total">
                <td>
                  <p class="value">Total</p>
                </td>
                <td>
                  <p class="price">₹{{ totalPrice | number : "1.2-2" }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          *ngIf="cartItems.length > 0"
          [routerLink]="['/checkout']"
          type="button"
          class="btn-theme btn-flat"
        >
          Proceed to checkout
        </button>
      </div>
    </div>
  </div>

  <ng-template #emptyCart>
    <div style="background-color: #f7f7f7" class="card" role="alert">
      <div style="text-align: center" class="card-body p-5">
        <div>
          <i style="font-size: 55px" class="fa fa-shopping-basket"></i>
        </div>
        <h3 class="mt-4">
          Your cart is <span style="color: #eb3e32">Empty !</span>
        </h3>
        <p>Must Add items to cart before checkout</p>

        <button
          style="padding: 12px"
          [routerLink]="['/products']"
          type="button"
          class="btn-theme"
        >
          <i class="fa fa-shopping-bag"></i> Return to Shop
        </button>
      </div>
    </div>
  </ng-template>
</div>
